module.exports = __webpack_public_path__ + "img/IMG_1867_L_BlackMatted.d9893fc5.jpg";